import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import { adminUsersQueryOptions } from "./users.queries";
import type { AdminUser } from "./users.types";

export const setUserRoleMutation = mutationOptions({
	mutationFn: (vars: { id: string; role: AdminUser["role"] }) =>
		api.post(`/platform/admin/users/${vars.id}/role`, { role: vars.role }),
	onSuccess: () =>
		queryClient.invalidateQueries({
			queryKey: adminUsersQueryOptions.queryKey,
		}),
});
